{
  "name": "research-lake-explorer",
  "version": "0.4.0",
  "private": true,
  "scripts": {
    "start": "mkdir -p .parcel-tmp && TMPDIR=$PWD/.parcel-tmp parcel src/index.html --port 3020 --host 0.0.0.0",
    "build": "mkdir -p .parcel-tmp && TMPDIR=$PWD/.parcel-tmp parcel build src/index.html --dist-dir dist --public-url ./",
    "typecheck": "tsc --noEmit",
    "test:unit": "node --test tests/*.test.ts"
  },
  "dependencies": {
    "lucide-react": "^1.69.0",
    "react": "^19.0.0",
    "react-dom": "^19.0.0"
  },
  "devDependencies": {
    "@parcel/resolver-default": "^2.16.4",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "parcel": "2.16.4",
    "typescript": "^6.0.3"
  }
}
